/**
 * Enums compartidos entre apps/api y apps/web.
 * Se mantienen como const objects + union types (en vez de `enum` de TS)
 * para que sean 100% compatibles con Prisma y con Zod sin duplicar valores.
 */
export const ROLES = ["ADMIN", "CAJERO", "MESERA"];
/** Estado real de la sesión de mesa, tal como se guarda en la base de datos. */
export const ESTADOS_MESA_SESION = ["ABIERTA", "CUENTA_PEDIDA", "CERRADA"];
/**
 * Estado visual de una mesa en la pantalla de salón (sección 5 del diseño).
 * Se calcula en el backend combinando mesa_sesiones + usuario autenticado,
 * no se guarda directamente en la base de datos.
 */
export const ESTADOS_MESA_UI = [
    "LIBRE",
    "MIA",
    "PIDIO_CUENTA",
    "SOLICITUD_QR",
    "OTRA_MESERA",
];
export const TIPOS_MOVIMIENTO_MESA = [
    "MOVER",
    "UNIR",
    "DESBLOQUEAR",
    "CANCELAR",
    "REVERTIR_COBRO",
];
export const UNIDADES_MEDIDA_INSUMO = ["KILOGRAMO", "GRAMO", "LITRO", "MILILITRO", "UNIDAD"];
export const TIPOS_MOVIMIENTO_INSUMO = [
    "ENTRADA_COMPRA",
    "SALIDA_VENTA",
    "AJUSTE_MERMA",
    "INICIAL",
    "REVERSION_COBRO",
];
//# sourceMappingURL=enums.js.map